import { format, isValid, parseISO } from "date-fns";
import { COLUMN_DEFS, COLUMN_VISIBILITY_KEY } from "./participantsListConstants";

export function formatDateCell(value) {
  if (value == null || value === "") return "—";
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d) && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
      d = new Date(raw.replace(" ", "T"));
    }
    if (!isValid(d)) d = new Date(raw);
    return isValid(d) ? format(d, "PP") : "—";
  } catch {
    return "—";
  }
}

export function formatDateTimeCell(value) {
  if (value == null || value === "") return "—";
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d) && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
      d = new Date(raw.replace(" ", "T"));
    }
    if (!isValid(d)) d = new Date(raw);
    return isValid(d) ? format(d, "PPp") : "—";
  } catch {
    return "—";
  }
}

export function formatMoney(value) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  return Number.isFinite(n) ? `₹${n.toFixed(2)}` : "—";
}

export function isTruthyBool(v) {
  return v === true || v === 1 || v === "1";
}

export function yesNo(v) {
  return isTruthyBool(v) ? "Yes" : "No";
}

export function stripPaymentLinkTags(raw) {
  return String(raw ?? "")
    .replace(/\[\[tid:\d+\]\]/g, "")
    .replace(/\[\[mid:\d+\]\]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function remarksDisplay(value) {
  if (value == null) return null;
  const s = stripPaymentLinkTags(value);
  if (s === "" || s.toLowerCase() === "null") return null;
  return s;
}

export function cellValue(columnId, row) {
  switch (columnId) {
    case "tournament_date":
    case "tour_registration_date":
    case "student_date_of_birth":
      return formatDateCell(row[columnId]);
    case "registration_created_at":
      return formatDateTimeCell(row[columnId]);
    case "payment_date":
      return formatDateCell(row[columnId]);
    case "amount_paid":
    case "participation_fee":
      return formatMoney(row[columnId]);
    case "payment_verified":
    case "registration_verified":
      return yesNo(row[columnId]);
    case "payment_remarks": {
      const s = remarksDisplay(row[columnId]);
      if (s == null) return null;
      return s.length > 80 ? `${s.slice(0, 77)}…` : s;
    }
    case "payment_proof":
      return row.payment_proof ? "Yes" : "—";
    default:
      return row[columnId] ?? "—";
  }
}

export function rawSortValue(row, columnId) {
  switch (columnId) {
    case "payment_verified":
    case "registration_verified":
      return isTruthyBool(row[columnId]) ? 1 : 0;
    case "amount_paid":
    case "participation_fee": {
      const n = Number(row[columnId]);
      return Number.isFinite(n) ? n : 0;
    }
    case "tournament_date":
    case "tour_registration_date":
    case "payment_date":
    case "student_date_of_birth":
    case "registration_created_at": {
      const raw = row[columnId];
      if (raw == null || raw === "") return 0;
      const t = new Date(raw).getTime();
      return Number.isFinite(t) ? t : 0;
    }
    default: {
      const v = row[columnId];
      if (v == null) return "";
      return String(v).toLowerCase();
    }
  }
}

export function compareByColumn(a, b, columnId) {
  const va = rawSortValue(a, columnId);
  const vb = rawSortValue(b, columnId);
  if (typeof va === "number" && typeof vb === "number") {
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  }
  return String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: "base" });
}

export function loadSavedColumnVisibility() {
  try {
    const raw = localStorage.getItem(COLUMN_VISIBILITY_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }
  return null;
}

export function createInitialColumnVisibility() {
  const saved = loadSavedColumnVisibility();
  const initial = {};
  for (const c of COLUMN_DEFS) {
    initial[c.id] = saved?.[c.id] ?? c.defaultVisible;
  }
  return initial;
}
